import { render, staticRenderFns } from "./HorizontalCarousel.vue?vue&type=template&id=6a7574a8&"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js&"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports